import cx from 'classnames';
import { useCallback, type FunctionComponent } from 'react';

import CalendarPlusIcon from '@atlaskit/icon/core/calendar-plus';
import CloseIcon from '@atlaskit/icon/core/close';
import MergeSuccessIcon from '@atlaskit/icon/core/merge-success';

import {
  IslandNav,
  IslandNavButton,
  IslandNavSeparator,
} from 'app/src/components/IslandNav';
import { bulkActionSelectedCardsSharedState } from './bulkActionSelectedCardsSharedState';
import { useIsBulkActionEnabled } from './useIsBulkActionEnabled';

import * as styles from './BulkActionIsland.module.less';

export interface BulkActionIslandProps {
  isVisible?: boolean;
}

export const BulkActionIsland: FunctionComponent<BulkActionIslandProps> = ({
  isVisible = false,
}) => {
  const isBulkActionEnabled = useIsBulkActionEnabled();

  const unSelectAllCards = useCallback(() => {
    bulkActionSelectedCardsSharedState.setValue(() => ({}));
  }, []);

  if (!isBulkActionEnabled) {
    return null;
  }

  return (
    <IslandNav
      buttonGroupClassName={styles.buttonGroup}
      className={cx(styles.bulkActionIsland, {
        [styles.visible]: isVisible,
        [styles.hidden]: !isVisible,
      })}
    >
      <IslandNavButton
        icon={<CalendarPlusIcon label="Schedule" />}
        onClick={() => {}}
        title="Schedule"
        label="Schedule"
        showLabels={true}
      />
      <IslandNavButton
        icon={<MergeSuccessIcon label="Merge" />}
        onClick={() => {}}
        title="Merge"
        label="Merge"
        showLabels={true}
        isDisabled={false}
      />
      <IslandNavSeparator />
      <IslandNavButton
        icon={<CloseIcon label="Unselect" />}
        onClick={unSelectAllCards}
        title="Unselect"
        label="Unselect"
        showLabels={true}
      />
    </IslandNav>
  );
};
